module.exports = __webpack_public_path__ + "assets/img/mangement.217c5f11.png";